import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'confirm-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})


export class ConfirmationDialogComponent {

  /**
   * Die anzuzeigende Überschrift im Dialog
   */
  public title = 'Speichern';

  /**
   * Die anzuzeigende Nachricht im Dialog
   */
  public message = 'Möchten Sie jetzt Speichern?';

  /**
   * @var string
   */
  public confirmationMessage = 'Speichern';

  /**
   * @var string
   */
  public declineMessage = 'Schließen';

  constructor(public activeModal: NgbActiveModal) {}

  /**
   * Setter für die Message Eigenschaft
   *
   * @param string
   */
  public setMessages = ([title, message]: string[]) =>  {
    this.title = title;
    this.message = message;
  }

  /**
   * Setzt die texte für die Buttons
   *
   * @param [confirm, decline]: string[]
   */
  public setButtonMessages = ([confirm, decline]: string[]) => {
    this.confirmationMessage = confirm;
    this.declineMessage = decline;
  }

  public closeModal = (confirmed: boolean) => {
    this.activeModal.close(confirmed);
  }
}
